import React, { useState } from "react";
import { AppLayout } from "../../layout/Index";
import {
  MdOutlineKeyboardArrowUp,
  MdOutlineKeyboardArrowDown,
} from "react-icons/md";
import { AiOutlineHeart } from "react-icons/ai";
import {
  RoadmapWrapper,
  RoadmapContainer,
  FaqOutWrapper,
  FaqContainer,
  FaqDisplayContainer,
  FaqWrapper,
  FaqTitle,
  FaqItemContainer,
  FaqContent,
  MemberShipOutWrapper,
  MemberShipWrapper,
  MemberShipsContainer,
  MemberShipCard,
  CardTitle,
  CardContent,
  CardList,
} from "./style";

const cardData = [
  {
    mark: "assets/membership.svg",
    title: "Phase 01",
    desc: "Pre Launch",
    getList: [
      "Official launch of the Stellar Art platform",
      "Release of Stellar Artist NFT collection (limited to 500 NFTs)",
      "Implement and release the (Turn Text into an Image) feature",
      "Raise Liquidity",
      "Establish a vibrant community of early adopters on Discord and other social media platforms",
    ],
    delay: 300
  },
  {
    mark: "assets/membership.svg",
    title: "Phase 02",
    desc: "Post Launch",
    getList: [
      "Release of ERC-20 token Stellar Token (STAI) to facilitate platform transactions and governance",
      "Develop and launch the (Turn Image into an Image) feature",
      "Implementation of community-driven governance for feature and model suggestions using Stellar Token",
      "Organize exclusive competitions and art showcases for Stellar Artist NFT holders",
      "Collaborations with renowned artists and influencers to expand Stellar Art's reach",
      "Cross-platform integration, allowing users to share and export creations easily",
    ],
    delay: 600
  },
  {
    mark: "assets/membership.svg",
    title: "Phase 03",
    desc: "Global Expansion",
    getList: [
      "Develop and launch the (Turn Text into a Video) feature, expanding the platform's creative capabilities",
      "Regularly scheduled surprise drops, events, and platform updates for the community",
      "Launch a mobile app for iOS and Android, providing on-the-go access to the Stellar Art platform",
      "Exploration of AR and VR applications, bringing AI-generated creations to new mediums",
      "Development of NFT Marketplace and Prompt Marketplace for only AI Generated NFTs artwork",
    ],
    delay: 900
  },
];

const faqData = [
  {
    title: "How does the Stellar Art AI Image Generator work?",
    text: "The Stellar Art AI Image Generator uses carefully curated prompts and an intuitive interface to allow users to create unique and visually stunning images in over 30+ models. The advanced algorithms provide lightning-fast results in just seconds.",
  },
  {
    title: "What is the Stellar Artist NFT Collection?",
    text: "The Stellar Artist NFT Collection is a limited-edition series of 500 NFTs that grant holders a lifetime subscription to the Stellar Art AI Image Generator. NFT holders also receive first access to unreleased beta models, access to every cutting-edge model, and other future perks.",
  },
  {
    title: "What are the key features of Stellar Art?",
    text:  "Turn text into an image",
    text1: "Turn an image into another image",
    text2: "Turn text into a video",
    text3: "Turn an image into an NFT"
  },
  {
    title: "How much does it cost to mint a Stellar Artist NFT?",
    text: "The mint price for a Stellar Artist NFT is 0.05 ETH.",
  },
  {
    title: "Where can I ask more questions?",
    text: "Please join our Discord community. We're usually online and happy to answer any questions. You can also contact us at contact@stellartai.com",
  },
];

const Roadmap = () => {
  const [selectFAQ, setSelectFAQ] = useState(0);
  const [isOpen, setOpen] = useState(false);

  const handleFAQ = (index: number) => {
    if (index === selectFAQ) {
      setOpen(!isOpen);
    }
    setSelectFAQ(index);
  };

  return (
    <AppLayout>
      <RoadmapWrapper>
        <RoadmapContainer>
          <MemberShipOutWrapper>
            <MemberShipWrapper>
              <MemberShipsContainer>
                {cardData.map((item, key) => (
                  <MemberShipCard key={`membercard${key}`} data-aos="fade-up" data-aos-delay={`${item.delay}`}>
                    <CardTitle>
                      <div>
                        <img src={item.mark} alt="" />
                        {item.title}
                      </div>
                      <span>
                        <b>{`${item.desc}`}</b>
                      </span>
                    </CardTitle>
                    <CardContent>
                      <CardList>
                        {item.getList.map((card, key) => (
                          <div key={`membercardgetlist${key}`}>
                            <AiOutlineHeart color="#E11D48" /> {card}
                          </div>
                        ))}
                      </CardList>
                    </CardContent>
                  </MemberShipCard>
                ))}
              </MemberShipsContainer>
            </MemberShipWrapper>
          </MemberShipOutWrapper>
          <FaqOutWrapper>
            <FaqContainer>
              <FaqDisplayContainer>FAQs</FaqDisplayContainer>
              <FaqWrapper>
                {faqData.map((item, key: number) => (
                  <FaqItemContainer
                    key={`faqlist${key}`}
                    onClick={() => handleFAQ(key)}
                  >
                    <FaqTitle>
                      <span>{item.title}</span>
                      {selectFAQ === key && isOpen ? (
                        <MdOutlineKeyboardArrowUp size={25} />
                      ) : (
                        <MdOutlineKeyboardArrowDown size={25} />
                      )}
                    </FaqTitle>
                    {selectFAQ === key && isOpen && (
                      <FaqContent
                        className={selectFAQ === key && isOpen ? "open" : ""}
                      >
                        {item.text}<br></br>
                        {item.text1}<br></br>
                        {item.text2}<br></br>
                        {item.text3}
                      </FaqContent>
                    )}
                  </FaqItemContainer>
                ))}
              </FaqWrapper>
            </FaqContainer>
          </FaqOutWrapper>
        </RoadmapContainer>
      </RoadmapWrapper>
    </AppLayout>
  );
};

export default Roadmap;
